// eslint-disable-next-line unicorn/prefer-module
const windowUrl = require('./windowUrl');

const PREFIX_REGEX = /^https?:\/\/[^/]+/;

const getOriginWithPrefix = (requestUrl) => {
  const url = requestUrl || windowUrl;

  const [originWithPrefix] = url.match(PREFIX_REGEX);
  return originWithPrefix;
};

// eslint-disable-next-line unicorn/prefer-module
module.exports = getOriginWithPrefix;
